<script setup>
import { ref, inject } from "vue";
import NProgress from "nprogress";
import Notifications from "@Components/Notifications.vue";

const pending = () => {
    NProgress.start();
};
const resolve = () => {
    NProgress.done();
};
const fallback = () => {
    NProgress.done();
};

const notifications = ref();
const setNotificationComponent = inject("setNotificationComponent");
setNotificationComponent(notifications);
</script>

<template>
    <div>
        <div class="flex flex-col flex-1 overflow-auto">
            <main class="flex flex-1 min-h-screen">
                <RouterView v-slot="{ Component }">
                    <Transition name="fade-75" mode="out-in">
                        <Suspense @pending="pending" @resolve="resolve" @fallback="fallback">
                            <Component :is="Component" />
                        </Suspense>
                    </Transition>
                </RouterView>
            </main>
        </div>

        <Notifications ref="notifications" />
    </div>
</template>
